export const CUSTOMER_SUPPORT_BOOSTER_COOKIE_NAME =
  'showCustomerSupportBooster';
export const CUSTOMER_SUPPORT_BOOSTER_TIMEOUT = 1000 * 60 * 2;
